import { cn } from "ui";
import { PaymentDefaultCardSkeleton } from "../primitives/PaymentDefaultCardSkeleton";

type PaymentDefaultCardGridSkeletonProps = {
  /** Number of card placeholders. */
  count?: number;
  /** Classes for the grid wrapper (override the default responsive columns). */
  className?: string;
};

export const PaymentDefaultCardGridSkeleton = ({
  count = 6,
  className,
}: PaymentDefaultCardGridSkeletonProps) => (
  <div
    className={cn(
      "grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3",
      className
    )}
  >
    {Array.from({ length: count }).map((_, i) => (
      <PaymentDefaultCardSkeleton key={i} />
    ))}
  </div>
);
